import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export const sort = (arr, key) => {
  if ((arr === null || arr === void 0 ? void 0 : arr.length) === 0) return arr;
  return arr === null || arr === void 0 ? void 0 : arr.sort((a, b) => {
    const nameA = isNaN(a[key]) ? a[key].toLowerCase() : Number(a[key]);
    const nameB = isNaN(b[key]) ? b[key].toLowerCase() : Number(b[key]);
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
};
export function remove(array, element, attr) {
  let index = -1;
  if (attr) {
    index = array.findIndex(item => item[attr] === element);
  } else {
    index = array.indexOf(element);
  }
  if (index > -1) {
    array.splice(index, 1);
  }
}
export const arrayToObject = (array, key) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return _objectSpread(_objectSpread({}, obj), {}, {
      [item[key]]: item
    });
  }, initialValue);
};
export function sortByProp(arr, prop, t) {
  if (!arr || !prop) return [];
  return arr.sort((a, b) => {
    const aProp = t ? t(a[prop]) : a[prop];
    const bProp = t ? t(b[prop]) : b[prop];
    if (aProp < bProp) {
      return -1;
    }
    if (aProp > bProp) {
      return 1;
    }
    return 0;
  });
}
export function getUniqueKeys(arr, key) {
  const uniqueKeys = arr.map(e => e[key]).map((e, i, final) => final.indexOf(e) === i && i).filter(e => arr[e]).map(e => arr[e]);
  return uniqueKeys;
}